import axios from '../axios'

export default class FAQ {
  async GetAll(params) {
    const response = await axios.get(`/get-faqs`, { params })

    return response.data
  }
   

}
